<template>
  <div>
    <div
      v-show="show"
      class="chat_menu-wrapper"
    >

    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

interface DataType {
  show: boolean;
}

export default defineComponent({
  name: 'chatMenu',

  data(): DataType {
    return {
      show: true,
    };
  },

  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.chat_menu-wrapper {
  position: relative;
  height: 40px;
  width: 90%;
  background-color: red;
}
</style>
